import React from "react";

export function Main({ children, styles }) {
    return (
        <main className={styles.main}>
            {children}
        </main>
    );
}